import { Breakpoint, iconClasses, typographyClasses } from "@mui/material"
import { blueGrey } from "../../themes/palette"
import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ breakpoints }) => ({
  root: {
    display: "flex",
    flex: 1,
    flexWrap: "wrap",
    justifyContent: "space-between",
    rowGap: 10
  },
  searchInput: {
    width: "250px",

    [`& .${iconClasses.root}`]: {
      color: blueGrey[400],
      lineHeight: "normal"
    },

    [breakpoints.down("sm" as Breakpoint)]: {
      width: "150px"
    }
  },
  subContainer: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap"
  },
  select: {
    minWidth: "150px"
  },
  sortIcon: {
    color: blueGrey[400]
  },
  checkbox: {
    maxHeight: "30px",
    [`& .${typographyClasses.root}`]: {
      fontSize: "0.785rem",
      lineHeight: "1.25rem",
      color: blueGrey[600],
      fontWeight: 500
    },
    "& .MuiCheckbox-root svg rect": {
      stroke: blueGrey[600]
    }
  }
}))
